export default __webpack_public_path__ + "static/media/login.49ce24c8.jpg";